import { Blue, Gray, White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginRight: 32,
  width: 256,
  minWidth: 256,
  height: 352,
  background: 'rgba(48, 54, 66, 0.8)',
  border: 'solid',
  borderColor: 'transparent',
  borderWidth: 4,
  borderRadius: '8px',
  color: Gray.Gray60
});

export const focused = css({
  border: 'solid',
  height: 352,
  borderWidth: 4,
  borderColor: Blue.Blue60
});

export const icon = css({
  maxWidth: '264px',
  maxHeight: '220px'
});

export const iconContainer = css({
  flex: 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

export const textContainer = css({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  padding: '0px 28px 10px',
  fontWeight: 700
});

export const title = css({
  whiteSpace: 'pre-wrap',
  fontSize: '22px',
  color: White.White10
});

export const description = css({
  whiteSpace: 'pre-wrap',
  marginTop: 8,
  fontSize: '16px',
  color: White.White10Alpha60
});
